import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Instant} from "@js-joda/core";
import {environment} from "../../../environments/environment";

export interface ImageHistoryEntry {
    time: string;
    imageUrl: string;
    triggerType: string;
    anomaly: boolean;
    anomalyDescription: string | null;
}

@Injectable({providedIn: "root"})
export class AssetImageHistoryService {
    private readonly http = inject(HttpClient);

    getHistory(assetMeteringId: number, from: Instant, to: Instant): Observable<{items: ImageHistoryEntry[]}> {
        return this.http.get<{items: ImageHistoryEntry[]}>(
            `${environment.apiServerUrl}/assets/meterings/${assetMeteringId}/image-history`,
            {params: {dateFrom: from.toString(), dateTo: to.toString()}},
        );
    }
}
